import { isEmpty } from 'lodash';

export function setLightsForChapters(chapters: any[], assetLibLights: string[]) {
  return chapters.map((chapter) => {
    // leave chapter lights alone if already set.
    if (!isEmpty(chapter.lights)) {
      return chapter;
    }

    // set the lights according to the contents of assetLibraries
    const lights = {
      libraries: [...assetLibLights],
      lights: [], // tbh, no idea why this prop exists.
    };

    return { ...chapter, lights };
  });
}
